import { type FC } from 'react';
import { DialogClose, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { AssetThumbnail } from '@/components/asset-thumbnail';
import { Button } from '@/components/ui/button';
import { type Asset } from '@/types/asset';
import { useTranslations } from 'next-intl';

export type AssetPreviewContentProps = {
  name: string;
  type?: string | null;
  thumbnail?: string;
  asset?: Asset;
  variantKey?: string;
  renderVideoPlayer?: boolean;
  disablePolling?: boolean;
  onClose?: () => void;
  autoFocusClose?: boolean;
};

// Shared by the Downloads variant preview, the active-version preview, and the past-version
// preview dialog so the three can't silently drift back out of sync (DM-2391).
export const AssetPreviewContent: FC<AssetPreviewContentProps> = ({
  name,
  type,
  thumbnail,
  asset,
  variantKey,
  renderVideoPlayer,
  disablePolling,
  onClose,
  autoFocusClose = false,
}) => {
  const tCommon = useTranslations('common');

  return (
    <>
      <DialogHeader>
        <DialogTitle>{name}</DialogTitle>
        <DialogDescription className="sr-only" />
      </DialogHeader>
      <AssetThumbnail
        name={name}
        type={type}
        thumbnail={thumbnail}
        asset={asset}
        variantKey={variantKey}
        renderVideoPlayer={renderVideoPlayer}
        disablePolling={disablePolling}
        imageContainerClassName="relative aspect-square w-full bg-ui-panel flex items-center justify-center max-h-[calc(100vh-150px)]"
        imageClassName="max-w-full max-h-full w-auto h-auto object-contain"
        iconContainerClassName="flex w-full items-center justify-center h-full"
        iconClassName="stroke-ui-light icon-16"
      />
      <DialogFooter>
        <DialogClose autoFocus={autoFocusClose} asChild>
          <Button type="button" onClick={onClose} variant="secondary">
            {tCommon('close')}
          </Button>
        </DialogClose>
      </DialogFooter>
    </>
  );
};
